import React, { useRef, useState } from "react";
import useDismissOnOutside from "../../components/useDismissOnOutside";

export default function RowActionsMenu({
  canEdit,
  canDelete,
  onEdit,
  onChangeFromPrior,
  onDelete,
  onPrint,
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useDismissOnOutside(ref, open, () => setOpen(false));

  const fire = (handler) => () => {
    setOpen(false);
    handler();
  };

  const items = [
    {
      label: "Edit",
      icon: "✏️",
      enabled: canEdit,
      title: canEdit ? "Edit invoice" : "Only managers can edit this invoice",
      onClick: fire(onEdit),
    },
    {
      label: "Change from Prior",
      icon: "📄",
      enabled: true,
      title: "Open a new invoice pre-filled from this one",
      onClick: fire(onChangeFromPrior),
    },
    {
      label: "Print",
      icon: "🖨️",
      enabled: true,
      title: "Open this invoice in a new tab and print it",
      onClick: fire(onPrint),
    },
    {
      label: "Delete",
      icon: "🗑️",
      enabled: canDelete,
      title: canDelete ? "Delete invoice" : "Only managers can delete this invoice",
      onClick: fire(onDelete),
      danger: true,
    },
  ];

  return (
    <span ref={ref} style={{ position: "relative", display: "inline-block" }}>
      <button
        type="button"
        aria-label="Row actions"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="px-2 py-1 rounded-md text-gray-500 hover:bg-gray-100 hover:text-gray-700"
      >
        ⋯
      </button>
      {open && (
        <div
          role="menu"
          className="absolute right-0 z-40 mt-1 bg-white border rounded-md shadow-lg py-1 min-w-[190px]"
        >
          {items.map((item) => (
            <button
              key={item.label}
              role="menuitem"
              type="button"
              disabled={!item.enabled}
              title={item.title}
              onClick={item.onClick}
              className="flex items-center gap-2 w-full text-left px-3 py-1.5 text-sm disabled:cursor-not-allowed enabled:hover:bg-gray-50"
              style={{
                color: !item.enabled ? "#9ca3af" : item.danger ? "#dc2626" : "#374151",
              }}
            >
              <span aria-hidden="true">{item.icon}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      )}
    </span>
  );
}
